"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ARI = function ARI(props) {
  var size = props.size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    preserveAspectRatio: "xMidYMid slice",
    clipRule: "evenodd",
    fillRule: "evenodd",
    viewBox: "0 0 560 400",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m414.989 275.172c.641-33.24-25.469-56.855-25.469-56.855-2.819-21.013-10.456-51.407-51.147-73.849-61.787-34.051-95.973-6.238-193.373-65.9 2.027 11.154 8.446 26.59 16.623 36.178l-10.071-3.303c7.323 15.43 19.046 29.426 25.185 33.97l-11.288-3.548c11.958 29.344 35.321 46.725 35.321 46.725 5.324 44.926 38.279 52.58 40.942 80.211 42.931 6.656 88.312 52.629 88.312 52.629 23.759-40.841 56.889-48.756 84.969-46.258"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m333.217 150.096c-44.762-24.534-99.468-8.604-169.368-51.91 6.925 20.695 50.189 44.932 50.189 44.932l-38.283-12.447c9.75 16.92 49.66 38.121 49.66 38.121l-35.704-11.537c14.788 24.563 48.337 41.14 48.337 41.14l-20.618-1.492c2.669 23.095 34.575 42.981 36.271 60.803 14.434 5.516 33.031 15.133 47.53 27.597 27.715-13.625 20.072-59.72-32.77-125.108 72.681 4.393 70.676 58.275 112.393 50.528-3.059-14.474-5.033-37.261-47.635-60.63",
    fill: "#97233f"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m360.018 217.344c-9.337 15.028-25.122 10.84-30.749-7.898l11.381.693c-9.978-5.969-19.041-14.754-26.047-23.409-2.061 41.395 36.893 59.977 49.778 30.905-1.456-.011-2.912-.11-4.363-.291",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m381.102 222.609c-5.166 10.568-17.772 17.359-28.846 20.436 25.998 3.116 47.377 13.456 57.554 23.585-2.336-17.103-17.687-37.048-28.709-44.021zm-26.145 30.049c-1.439.043-2.872.131-4.296.271 0 0 7.789 13.239 3.507 27.827 16.905-9.49 38.687-14.086 54.597-10.876-9.542-8.072-32.236-17.868-53.808-17.224z",
    fill: "#ffb612"
  }));
};

ARI.propTypes = {
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
ARI.defaultProps = {
  size: '100'
};
var _default = ARI;
exports["default"] = _default;